export default __webpack_public_path__ + "static/TeamDavidKing-ae5cdd9e76807eb5618970d4325c6f8e.png";